// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PictureDescription_wrapper__fA5hb","expanded":"PictureDescription_expanded__3srwM","cover":"PictureDescription_cover__2mwTx","icon":"PictureDescription_icon__14Dcs"};